<template>
    <v-dialog
            v-model="modalOpen"
            width="500"
    >
        <template v-slot:activator="{ on }">
            <div
                    class="under-bar mb-8 text-right"
                    v-on="on">
                <div
                        class="main-number headline"
                        :style="{color: color}"
                        style="line-height: 1;"
                >
                    {{mainNumber }}
                </div>
                <div class="title">
                    <span class="title"
                         :style="{color: color}"
                         v-html="title" />
                    <span class="per-year">
                         {{ $t('overview.yearly') }}
                    </span>
                </div>
                <div class="secondary-number body-2"
                     :class="{overage: parseInt(secondaryNumber) > 100}"
                     v-if="secondaryNumber">
                    <span class="val">
                        {{secondaryNumber}}
                    </span>
                    <span class="label">{{secondaryNumberLabel}}</span>
                </div>
            </div>
        </template>
        <v-card>
            <v-toolbar flat dark color="#333333">
                <v-toolbar-title>
                    <v-icon class="mr-3">mdi-information-outline</v-icon>
                    {{ $t('overview.projected') }} {{title}}
                </v-toolbar-title>
            </v-toolbar>
            <div class="subtitle-1 ma-5">
                <div v-if="type==='cost'">
                    <i18n path="overviewDetail.costParagraph1" tag="p">
                        <template #subscriptions>
                            <color-highlighted-phrase color-key="subr" :text="$t('overviewDetail.subscriptions')"/>
                        </template>
                        <template #subscribedCount>
                            <strong>{{ numJournalsSubscribed | round }}</strong>
                        </template>
                        <template #illCosts>
                            <color-highlighted-phrase color-key="ill" :text="$t('overviewDetail.illCosts')"/>
                        </template>
                        <template #remainingCount>
                            {{ numJournals - numJournalsSubscribed | round }}
                        </template>
                    </i18n>
                    <i18n path="overviewDetail.costParagraph2" tag="p">
                        <template #cost>
                            <strong>{{ mainNumber }}/{{ $t('overview.yearly') }}</strong>
                        </template>
                        <template #percent>
                            {{ secondaryNumber }}
                        </template>
                    </i18n>
                </div>
                <div v-if="type==='usage'">
                    <i18n path="overviewDetail.usageParagraph1" tag="p">
                        <template #count>
                            <strong>{{ numJournals }}</strong>
                        </template>
                        <template #usage>
                            <strong>{{ mainNumber }} {{ $t('overviewDetail.usageRequests') }}</strong>
                        </template>
                    </i18n>
                    <i18n path="overviewDetail.usageParagraph2" tag="p">
                        <template #percent>
                            <strong>{{ secondaryNumber }}</strong>
                        </template>
                        <template #freeSources>
                            <color-highlighted-phrase color-key="freeInstant" :text="$t('overviewDetail.freeSources')"/>
                        </template>
                        <template #subscriptionLinks>
                            <color-highlighted-phrase color-key="subr" :text="$t('overviewDetail.titleByTitleSubscriptions')"/>
                        </template>
                    </i18n>
                </div>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="modalOpen = false">{{ $t('common.close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import colorHighlightedPhrase from "../colorHighlightedPhrase";

    export default {
        components: {
            colorHighlightedPhrase,
        },
        name: "OverviewGraphicBarHeader",
        props: {
            title: String,
            type: String,
            mainNumber: String,
            secondaryNumber: String,
            secondaryNumberLabel: String,
            color: String,
            numJournals: Number,
            numJournalsSubscribed: Number,
        },
        data() {
            return {
                modalOpen: false,
            }
        },
        computed: {
            titleWithBreak() {
                return this.title.replace(" ", "<br>")
            },

        }
    }
</script>

<style scoped lang="scss">
    .under-bar {
        font-size: 18px;
        cursor: help;

        .secondary-number {
            &.overage {
                font-weight: bold;
                color: red;
            }
        }

        .first-row {
            line-height: 1;

            cursor: help;


        }

        i {
            display: none;
        }

    }

</style>